module.exports = __webpack_public_path__ + "media/images/help/about/eyecatch-reason-3-375f7a10905f4dbffb76c5a897cc36e5.jpg";